export const SelectionRange = {
    // User selects text from the same div
    SameDiv: "SameDiv",
    // User selects text from different divs in a single page
    DifferentDivs: "DifferentDivs",
    // User selects text in multiple pages
    DifferentPages: "DifferentPages",
};
